import React from 'react'
import {FaCheck, FaConciergeBell, FaMotorcycle, FaRegClock} from 'react-icons/fa'
import {MdRestaurantMenu} from 'react-icons/md'
import Timeline from '@components/V3/Timeline'
import useIsDarkMode from '@hooks/useIsDarkMode'
import isCompleted from '@page-components/TrackV2/helpers/isCompleted'
import isScheduledAndPending from '@page-components/TrackV2/helpers/isScheduledAndConfirming'
import useOrder from '@page-components/TrackV2/hooks/useOrder.main'
import useStatus, {TrackingStatus} from '@page-components/TrackV2/hooks/useStatus'

const mapStatusToStep = (status: TrackingStatus, deliveryType: string) => {
  if (status === 'confirmation') return 1
  if (status === 'preparation') return 2
  if (status === 'readyForPickup') return 3
  if (status === 'waitingForDelivery') return 3
  if (status === 'delivery') return 4
  if (isCompleted(status) && deliveryType === 'delivery') return 5
  if (isCompleted(status) && deliveryType === 'go') return 4
  if (isCompleted(status) && deliveryType === 'serve') return 3
  if (status === 'cancelled') return 0
}

const getIcon = (status: TrackingStatus) => {
  if (status === 'confirmation') return FaRegClock
  if (status === 'preparation') return MdRestaurantMenu
  if (status === 'readyForPickup' || status === 'waitingForDelivery') return FaConciergeBell
  if (status === 'delivery') return FaMotorcycle
  if (isCompleted(status)) return FaCheck

  return FaRegClock
}

export const TrackTimelineSkeleton = () => {
  return (
    <>
      <Timeline totalSteps={5} step={0} icon={<FaRegClock color="white" size={16} />} />
    </>
  )
}

const getTotalSteps = (deliveryType: string) => {
  if (deliveryType === 'delivery') return 5
  if (deliveryType === 'go') return 4
  if (deliveryType === 'serve') return 3

  return 5
}

export default function TrackTimeline() {
  const darkMode = useIsDarkMode()
  const {order} = useOrder()
  const status = useStatus()

  const Icon = getIcon(status)

  if (isScheduledAndPending(status, order) || status === 'cancelled' || status === 'inReview')
    return null

  return (
    <>
      <Timeline
        totalSteps={getTotalSteps(order.deliveryType)}
        step={mapStatusToStep(status, order.deliveryType)}
        icon={<Icon color={darkMode ? 'black' : 'white'} size={16} />}
      />
    </>
  )
}
